<gen-dynamic-form #newDynamicForm
  style="flex: 1;"
  [formName]="formId"
  [submitted]="editMode || isSubmitted"
  [disabled]="false"
  [editMode]="editMode"
  [overrides]="overrides"
  [disabledForced]="disabledForced"
  [popupMode]="popupMode"
  [title]="title"
  [formData]="sample"
  class="Auto_Specimen_Information"
  [updatedFieldsContext]="updatedFieldsContext"
  [updatedFieldsContextType]="updatedFieldsContextType"
  [submitButtonText]="(this.markAsPrimaryEnabled === true && this.proceedToAnaliseStarted === false && this.sample.isPrimary === false) ? 'Mark as Primary' : '' "
  (formChange)="updateForm($event)"
  (validateChange)="updateValidate($event)"
  (submitEmitter)="markSpecimenAsPrimary($event)"
></gen-dynamic-form>
